import {Link} from "@tanstack/react-router";
import {ShieldAlert} from "lucide-react";

import {Button} from "@/components/ui/button";

export default function Client() {
  return (
    <>
      <div className="text-center">
        <div className='flex justify-center'>
          <ShieldAlert data-testid='error:general:icon' className='size-60 my-6 text-secondary-accent-light' />
        </div>
        <p data-testid='error:general:text' className="text-lg font-medium text-pretty text-gray-500 sm:text-xl/8">Oops! Something went wrong.</p>
        <div className="mt-10 flex items-center justify-center gap-x-6" data-testid='error:general:button'>
          <Link to={'/'}>
            <Button variant='default'>Back to home</Button>
          </Link>
        </div>
      </div>
    </>
  )
}